import React from 'react'

const SignUp = () => {
  return (
    <div className="modal fade" id="signUpModal" tabIndex={-1} role="dialog" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered" role="document">
    <div className="modal-content bdr-radius">
      <div className="signin-wrapper">
        <div className="signin-wrapper-header text-center">
          <div className="logo"><img src="assets/images/elements/logo-icon.png" alt="image" /></div>
          <h3 className="title">Login with</h3>
          <p>Welcome back, please sign in below</p>
        </div>
        <form className="signin-form">
          <div className="form-group">
            <label htmlFor="signinEmail">Email*</label>
            <input type="email" className="form-control" id="signupEmail" placeholder="Enter your Email" />
          </div>
          <div className="form-group">
            <label htmlFor="signinPass">Password*</label>
            <input type="password" className="form-control" id="signupPass" placeholder="Password" />
          </div>
          <div className="form-group">
            <label htmlFor="signinPass">Confirm Password*</label>
            <input type="password" className="form-control" id="signupRePass" placeholder="Password" />
          </div>
          <div className="form-group">
            <div className="custom-checkbox">
              <input type="checkbox" name="id-2" id="id-2" defaultChecked />
              <label htmlFor="id-2">I do not want to be kept up to date about relevant investment opportunities, features, and events</label>
              <span className="checkbox" />
            </div>
          </div>
          <button type="submit" className="btn btn-primary btn-hover">Log In</button>
        </form>
        <div className="signin-wrapper-footer">
          <p className="bottom-text">Already have an account?<a href="#0" data-toggle="modal" data-target="#signInModal" data-dismiss="modal" aria-label="Close">Login</a></p>
          <div className="divider"><span>or</span></div>
          <ul className="social-list">
            <li><a href="#0"><i className="fa fa-facebook-f" /></a></li>
            <li><a href="#0"><i className="fa fa-twitter" /></a></li>
            <li><a href="#0"><i className="fa fa-linkedin" /></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}

export default SignUp
